export enum GlobalIds {
  eventTimetablePreview = 'EventTimetablePreview',
  globalAppLoader = 'globalAppLoader',
  venueRepertoire = 'VenueRepertoire'
}

export const getElementByGlobalId = (id: GlobalIds) => {
  return document.getElementById(id)
}
